import { FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

export interface DeleteSongContributionDialogProps {
  guid?: string;
  onClose: () => void;
  onConfirm: (guid: string) => void;
  affectsSplit?: boolean;
}

export const DeleteSongContributionDialog: FC<DeleteSongContributionDialogProps> = ({
  guid,
  onClose,
  onConfirm,
  affectsSplit,
}) => {
  const handleContributionDelete = () => {
    onClose();
    if (guid) {
      onConfirm(guid);
    }
  };

  return (
    <ChakraConfirmationDialog
      title="Delete Credit"
      message={`Are you sure you want to delete this credit? ${
        affectsSplit ? 'This may affect an existing split.' : ''
      }`}
      actionButtonText="Delete"
      isOpen={Boolean(guid)}
      handleAction={handleContributionDelete}
      onClose={onClose}
    />
  );
};
